<template>
  <el-dialog
    title=""
    :visible="true"
    :show-close="false"
    width="750px"
    center
    class="ts-modal"
  >
    <button
      type="button"
      aria-label="Close"
      class="el-dialog__headerbtn"
      @click="onCloseDialog(null)"
    >
      <i class="el-dialog__close el-icon el-icon-close"></i>
    </button>

    <h6 style="text-align: left">Search for Career Centers</h6>
    <p style="text-align: left; padding-bottom: 5px">
      See the list of Career Centers, based on their zip code, and see who is
      closest to you. Select the Career Centers you wish to connect with or
      already have a connection with. They will be sent a notification that you
      are interested in forming a connection and will assign you a staff or have
      your staff connect with you.
    </p>

    <el-row style="text-align: left">
      <!-- <el-col :xl="6" :lg="6" :md="12" :sm="0" :xs="0">&nbsp;</el-col>
       <el-col :xl="6" :lg="6" :md="12" :sm="0" :xs="0">&nbsp;</el-col> -->
      <el-col :xl="6" :lg="16" :md="24" :sm="24" :xs="24" class="label-right">
        <span>Filter by Distance </span>
      </el-col>
      <el-col :xl="6" :lg="6" :md="6" :sm="12" :xs="24">
        <el-select
          v-model="value"
          placeholder="Select"
          style="width: 200px"
          @change="filteredBy(value)"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-col>
    </el-row>

    <!-- <span style="font-size: 14px;font-weight: bold;padding-left: 350px;">Filter by Distance </span>
    <el-select v-model="value" placeholder="Select" style="width: 200px;" @change="filteredBy(value)">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select> -->

    <el-table :data="agencies" style="width: 100%" height="300px">
      <el-table-column
        prop="agencyName"
        label="Career Center Name"
        width="200"
        sortable
      >
      </el-table-column>
      <el-table-column prop="zipCode" label="Zipcode" width="150">
      </el-table-column>
      <el-table-column prop="distance" label="Distance" width="150" sortable>
        <template scope="scope">
          <el-tag v-if="scope.row.distance <= 50" type="success" effect="plain">
            {{ scope.row.distance }} miles away
          </el-tag>
          <el-tag
            v-else-if="scope.row.distance >= 50 && scope.row.distance <= 100"
            type="warning"
            effect="plain"
          >
            {{ scope.row.distance }} miles away
          </el-tag>
          <el-tag v-else type="danger" effect="plain">
            +{{ scope.row.distance }} miles away
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="connectionrequest"
        label="Request Connection"
        width="180"
      >
        <template scope="scope">
          <button
            class="ts-btn ts-btn-small"
            @click="goToPendingRequest(scope.row, $event)"
            v-if="scope.row.isInvited == true"
          >
            Connect
          </button>
          <button
            class="ts-btn ts-btn-small"
            @click="sendConnectionRequest(scope.row, $event)"
            v-else
          >
            Connect
          </button>
        </template>
      </el-table-column>
    </el-table>

    <div class="ts-modal_actions">
      <button
        class="ts-btn ts-btn-white ts-btn-small"
        @click="onCloseDialog(null)"
      >
        Close
      </button>
    </div>
    <!-- <loading 
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false">
    </loading> -->

    <TSLoading
      :active="isLoading"
      :defaultMessage="'Please wait...'"
      :altMessage="'Please hold on for a moment while we process the data...'"
    />
  </el-dialog>
</template>

<script>
import * as signalR from "@aspnet/signalr";
import TSLoading from "../../../components/TSLoading.vue";

export default {
  components: {
    TSLoading
  },
  created() {
    this.filteredBy("250");
    //TODO: Reevaluate code below
    // this.initializeSignalR();
  },
  data() {
    return {
      tableData: [],
      agencies: [],
      isLoading: false,
      options: [
        {
          value: "10",
          label: "Less than 10 miles"
        },
        {
          value: "25",
          label: "Less than 25 miles"
        },
        {
          value: "50",
          label: "Less than 50 miles"
        },
        {
          value: "75",
          label: "Less than 75 miles"
        },
        {
          value: "100",
          label: "Less than 100 miles"
        },
        {
          value: "101",
          label: "More than or equal to 100 miles"
        }
      ],
      value: "",
      connection: "",
      huburl: process.env.VUE_APP_MESSAGE_BASE_URI
    };
  },
  computed: {
    currentOrganisation() {
      return this.$store.state.organisation.current_organisation;
    },
    currentUser() {
      return this.$store.state.account.current_user;
    },
    zipCodes() {
      return this.$store.state.account.zipCodes;
    }
  },
  methods: {
    onCloseDialog(done) {
      this.$router.go(-1);
    },
    sendConnectionRequest(row, e) {
      this.isLoading = true;
      this.$store.dispatch("jobseeker/sendConnection", row).then(res => {
        if (res == "ConnectionRequestCreated") {
          this.$message.success("Connection Sent!");
          // Change button text to Sent and disabled
          e.target.innerText = "Sent";
          e.target.disabled = true;

          this.isLoading = false;
        } else if (res == "HasPendingRequest") {
          this.$confirm(
            `<p style="text-align:center;padding-bottom:20px;">You have a pending connection request in this Career Center. Click [Ok] button to go to 'Manage Career Center & Staff Requests' page. <br><br> 
                    If the connection request was initiated by the Career Center, you can accept or decline the connection request. <br><br> If you sent a connection request, you can send them a reminder.</p>`,
            "Warning",
            {
              confirmButtonText: "Ok",
              cancelButtonText: "Cancel",
              type: "warning",
              dangerouslyUseHTMLString: true,
              center: true
            }
          ).then(() => {
            this.$router.push({ name: "manage-agency-requests" });
          });
        } else if (res == "HasDeclinedInvite") {
          this.$confirm(
            `<p style="text-align:center;padding-bottom:20px;">Career Center has a pending connection request. Click [Ok] button to go to
                            'Manage Career Center & Staff Requests' page. <br><br> You must undo the decline connection first in order to approve Career Center's connection request.</p>`,
            "Warning",
            {
              confirmButtonText: "Ok",
              cancelButtonText: "Cancel",
              type: "warning",
              dangerouslyUseHTMLString: true,
              center: true
            }
          ).then(() => {
            this.$router.push({ name: "manage-agency-requests" });
          });
        } else this.$message.error("Request already exists");
        this.isLoading = false;
      });
    },
    filteredBy(radius) {
      this.isLoading = true;
      this.$store
        .dispatch("jobseeker/getagencies", radius)
        .then(res => {
          this.agencies = res;
          this.isLoading = false;
        })
        .catch(() => {
          var errMessage =
            "Your zip code is required in finding Career Centers. Please provide your zipe code in your skills profile.";
          this.$message.error(errMessage);
          this.isLoading = false;
        });
    },
    //TODO: Reevaluate code below
    // initializeSignalR() {
    //   this.connection = new signalR.HubConnectionBuilder()
    //     .withUrl(this.huburl, {
    //       transport:
    //         signalR.HttpTransportType.WebSockets |
    //         signalR.HttpTransportType.LongPolling,
    //       "content-type": "application/json",
    //       accessTokenFactory: () => localStorage.getItem("token"),
    //     })
    //     .build();

    //   this.connection.start().catch(function (err) {
    //     return console.error(err.toString());
    //   });
    // },
    goToPendingRequest(row, e) {
      this.$confirm(
        `<p style="text-align:center;padding-bottom:20px;">Job seeker has a pending connection request. Click [Ok] button to go to 'Manage New Job Seeker Requests' page and accept or decline the job seeker's
                    connection request.</p>`,
        "Warning",
        {
          confirmButtonText: "Ok",
          cancelButtonText: false,
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true
        }
      ).then(() => {
        this.$router.push({ name: "manage-agency-requests" });
      });
    }
  }
};
</script>

<style scoped>
.label-right {
  text-align: right;
  margin-right: 10px;
  margin-top: 10px;
  font-size: 14px;
  font-weight: bold;
}

@media screen and (max-width: 759px) {
  .label-right {
    text-align: left;
    margin-right: 10px;
    margin-top: 0px;
    font-size: 14px;
    font-weight: bold;
  }
}
</style>
